import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { CartProvider } from "./context/CartContext";
import { AdminAsesoriaProvider } from "./context/AdminAsesoriaContext";
import CartDrawer from "./components/feature/CartDrawer";
import MaintenanceGate from "./components/feature/MaintenanceGate";
import { Analytics } from "@vercel/analytics/react";

import { SiteSettingsProvider } from "./context/SiteSettingsContext";

import ScrollToTop from "./components/common/ScrollToTop";

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <SiteSettingsProvider>
        <CartProvider>
          <AdminAsesoriaProvider>
            <BrowserRouter basename={__BASE_PATH__}>
              <ScrollToTop />
              <MaintenanceGate>
                <AppRoutes />
                <CartDrawer />
              </MaintenanceGate>
              <Analytics />
            </BrowserRouter>
          </AdminAsesoriaProvider>
        </CartProvider>
      </SiteSettingsProvider>
    </I18nextProvider>
  );
}

export default App;